import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

export interface ProfilePagePaddingProps {
  /** Optional className override; merged via `cn()` over the base padding. */
  className?: string;
  children: ReactNode;
}

/**
 * Thin padding wrapper for tabs whose single child is self-laid-out (no
 * per-row gap) - currently the pipeline resume-viewer tab. Applies the
 * canonical `"px-4 pb-8 md:px-8"` padding only.
 *
 * The use of `<Profile.PagePadding>` at the call site self-documents the
 * intent: this tab manages its own internal layout, so the wrapper supplies
 * page padding without injecting a flex column or row gap.
 *
 * For the default `gap-6` stack variant, see {@link ProfileSectionStack}.
 */
export function ProfilePagePadding({
  className,
  children,
}: ProfilePagePaddingProps) {
  return (
    <div className={cn("px-4 pb-8 md:px-8", className)}>{children}</div>
  );
}
